"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var ForgotForm = /*#__PURE__*/function (_Vue) {
  function ForgotForm() {
    var _this;
    (0, _classCallCheck2.default)(this, ForgotForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ForgotForm, [].concat(args));
    (0, _defineProperty2.default)(_this, "form", {});
    (0, _defineProperty2.default)(_this, "rules", {});
    return _this;
  }
  (0, _inherits2.default)(ForgotForm, _Vue);
  return (0, _createClass2.default)(ForgotForm);
}(_vuePropertyDecorator.Vue);
ForgotForm = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], ForgotForm);
var _default = exports.default = ForgotForm;